import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_media_field = _resolveComponent("media-field")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: "Add/edit video",
    icon: "image",
    "is-processing": _ctx.isProcessing,
    "is-visible": $data.isVisible
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link gfu-link--accent",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, "cancel"),
      _createVNode(_component_icon_base_button, {
        size: "default",
        width: "compact",
        "text-transform": "none",
        wide: true,
        theme: "accent",
        icon: "check",
        enabled: !_ctx.isProcessing,
        onClick: _withModifiers($options.submit, ["prevent"]),
        "data-qa": "modal-button:Save"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Save", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["enabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_text_field, {
        modelValue: $data.model.url,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.url) = $event)),
        "display-name": "Video URL",
        description: "We support Youtube, Dailymotion, Vimeo and Twitch.",
        name: "model.url",
        "data-qa": "modal-field:VideoUrl"
      }, null, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_component_media_field, {
        modelValue: $data.model.imageUrl,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.imageUrl) = $event)),
        name: "model.imageUrl",
        "display-name": "Custom thumbnail",
        description: "Thumbnail will appear only for Dailymotion, Vimeo and Twitch clips.",
        "format-list": $props.formatList,
        "min-width": $props.minWidth,
        "min-height": $props.minHeight,
        ratio: $props.ratio,
        "upload-api-action": $props.uploadApiAction,
        "thumb-url": $data.model.imageUrl,
        "media-class": "gfu-field-media__image--expanded",
        onMediaUploaded: $options.onImageUploaded,
        onError: _ctx.handleError,
        "data-qa": "modal-field:ImageField"
      }, null, 8 /* PROPS */, ["modelValue", "format-list", "min-width", "min-height", "ratio", "upload-api-action", "thumb-url", "onMediaUploaded", "onError"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-processing", "is-visible"]))
}